import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';

//Deftere alınacak
export const translateDocType = (kaynakBelgeTuru) => {
    switch (kaynakBelgeTuru) {
        case 'invoice':
            return 'Fatura';
        case 'check':
            return 'Çek';
        case 'order-customer':
            return 'Müşteri Sipariş Belgesi';
        case 'order-vendor':
            return 'Satıcı Sipariş Belgesi';
        case 'voucher':
            return 'Senet';
        case 'shipment':
            return 'Navlun';
        case 'receipt':
            return 'Makbuz';
        case 'other':
            return 'Diğer';
        case '':
            return <Tag severity="danger" value={'BOŞ'} />;
        default:
            return kaynakBelgeTuru;
    }
};

export const docName = (docType, docExp) => {
    if (docType === 'Diğer' && (docExp === '' || docExp === null || docExp === undefined)) {
        return <Tag severity="danger" value={'BOŞ'} />;
    }

    switch (docExp) {
        case docType === 'Diğer' && ('' || null || undefined):
            return <Tag severity="danger" value={'BOŞ'} />;
        default:
            return docType;
    }
};

export const documentData = (docNo, docDate, title) => {
    if (docNo && !docDate) {
        if (title === 'kaynak_belge_tarihi') {
            return <Tag severity="danger" value={'BOŞ'} />;
        }
        return docNo;
    } else if (!docNo && docDate) {
        if (title === 'kaynak_belge_no') {
            return <Tag severity="danger" value={'BOŞ'} />;
        }
        return docDate;
    } else if (docNo && docDate) {
        return title === 'kaynak_belge_no' ? docNo : docDate;
    } else {
        return <Tag severity="danger" value={'BOŞ'} />;
    }
};

export const itemNo = (itemNo) => {
    if (itemNo) {
        return itemNo;
    } else if (itemNo === '' || itemNo === null || itemNo === undefined) {
        return '0';
    }
};

export const checkAmountAndCredit = (amount, credit, title) => {
    if ((amount === '' || amount === null || amount === undefined) && (credit === '' || credit === null || credit === undefined)) {
        return <Tag severity="danger" value={'BOŞ'} />;
    } else if (amount === 0 && credit === 0) {
        return <Tag severity="danger" value={'SIFIR olamaz.'} />;
    } else {
        let amount1 = new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY'
        }).format(title === 'borc' ? amount : credit);
        return <p> {amount1} </p>;
    }
};

export const controlSelectedReceipt = (data) => {
    if (data === null) {
        return false;
    }

    for (let i = 0; i < data.length; i++) {
        if (controlAllData(data[i]) === false) return false;
    }
    return true;
};

export const controlAllData = (data, messages = []) => {
    const receipt = data;
    const receiptDetails = data.altBasliklar;

    if (receipt.altBasliklar.length < 2) {
        messages.push('Fiş detayı en az 2 satır olmalıdır.');
        return false;
    }

    if (String(receipt.borc) === '0' && String(receipt.alacak) === '0') {
        messages.push('Borç ve alacak 0 olamaz.');
        return false;
    }

    if (receipt.borc !== receipt.alacak) {
        messages.push('Borç ve alacak eşit olmalıdır.');
        return false;
    }

    for (let i = 0; i < receiptDetails.length; i++) {
        if (receiptDetails[i].kaynak_belge_tipi_aciklama === '' || receiptDetails[i].kaynak_belge_tipi_aciklama === null || receiptDetails[i].kaynak_belge_tipi_aciklama === undefined) {
            if (receipt.belgesiz_fis === 1) {
                return true;
            }
            messages.push(`${i + 1}. satırda kaynak belge türü boş olamaz.`);
            return false;
        } else if (receiptDetails[i].kaynak_belge_tipi_aciklama === 'Diğer' && (receiptDetails[i].diger_tur_aciklama === '' || receiptDetails[i].diger_tur_aciklama === null || receiptDetails[i].diger_tur_aciklama === undefined)) {
            if (receipt.belgesiz_fis === 1) {
                return true;
            }
            messages.push(`${i + 1}. satırda 'Diğer' belge türü açıklaması boş olamaz.`);
            return false;
        }
    }

    if (receipt.belgesiz_fis === 0) {
        for (let i = 0; i < receiptDetails.length; i++) {
            if (receiptDetails[i].kaynak_belge_no === null || receiptDetails[i].kaynak_belge_no === '' || receiptDetails[i].kaynak_belge_tarihi === '' || receiptDetails[i].kaynak_belge_tarihi === null) {
                messages.push(`${i + 1}. satırda belgeli fiş için evrak no ve evrak tarihi zorunludur.`);
                return false;
            }
        }
    }

    return true;
};

export const rowIsTrue = (rowData) => {
    let messages = [];
    const check = controlAllData(rowData, messages);

    if (!check) {
        return <Button severity="danger" size="large" icon="pi pi-exclamation-triangle" tooltip={messages.length > 0 ? messages.join(', ') : 'Hatalı satır!'} tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }} />;
    }

    return <Button severity="success" icon="pi pi-check" tooltip="Doğru satır!" className="text-white" tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }} />;
};

export const wrongRow = (rowData) => {
    if (!controlAllData(rowData)) {
        return rowData;
    }
};
//Silindi
export const checkBorc = (rowData) => {
    let amount = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY'
    }).format(rowData.borc);

    return <p> {amount} </p>;
};

//Silindi
export const checkAlacak = (rowData) => {
    let amount = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY'
    }).format(rowData.alacak);

    return <p> {amount} </p>;
};

//Silindi
export const formatAmount = (money, formatType) => {
    let amount = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: formatType
    }).format(money);

    return <p> {amount} </p>;
};
